export default {
    data: () => ({
        alerts: [],
        isLoading: false
    }),

    methods: {
        async loadWhile(action, endState = false) {
            this.isLoading = true;
            try {
                return await action;
            } catch (err) {
                this.handleError(err);
                throw err;
            } finally {
                this.isLoading = endState;
            }
        },

        clearAlerts() {
            this.alerts = [];
        },

        handleError(apiErrorResponse) {
            const message = apiErrorResponse.response.data.message;
            if (message.includes("The details you have provided unfortunately don't match")) {
                this.addAlert({
                    type: 'error',
                    text: `The details you have provided unfortunately don't match our records. Please enter any information as it appears on your membership card.`
                });
            } else if (message.includes('Unable to find appointment')) {
                this.addAlert({
                    type: 'error',
                    text: `Sorry this appointments has already been taken - please select another time.`
                });
            } else if (message.includes('Unable to book appointments for bookings with a status')) {
                this.$modal.show(`systemLocked${this.serviceType}`);
            } else if (message.includes('The booking API service is currently unavailable')) {
                this.disableApp();
            } else if (message.includes('Expired')) {
                this.$modal.show(`sessionExpired${this.serviceType}`);
            } else {
                this.addAlert({
                    type: 'error',
                    text: `There has been an error processing your request. Please try again later or contact our friendly team for assistance.`
                });
            }
        },

        addAlert(alert) {
            // types: error, notice (to do), warn (to do), prompt (to do)
            if (!alert || !alert.type || !alert.text) return;
            this.alerts.push(alert);
            window.setTimeout(() => {
                this.alerts.shift();
            }, 10000);
        },
        disableApp() {
            document.querySelctor('#online-booking').classList.add('hidden');
            document.querySelctor('#online-booking-disabled').classList.remove('hidden');
        }
    }
};
